import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "@/lib/api";

const swap = async (url) => {
  try {
    const r = await fetch(url, { credentials: "include" });
    const html = await r.text();
    document.open(); document.write(html); document.close();
  } catch {
    document.body.innerHTML = "<p style='font-family:system-ui;padding:40px'>Não foi possível carregar esta página.</p>";
  }
};

// Serves the published page without any frame: fetches raw HTML and replaces the document
export default function PublicPage() {
  const { slug } = useParams();
  useEffect(() => { swap(`${API_URL}/api/p/${slug}`); }, [slug]);
  return <div data-testid="public-page-loading" />;
}

export function PublicFunnel() {
  const { slug, step } = useParams();
  useEffect(() => { swap(`${API_URL}/api/f/${slug}${step ? `/${step}` : ""}`); }, [slug, step]);
  return <div data-testid="public-funnel-loading" />;
}

// Custom domain: the whole site is the page bound to this host
export function DomainPage() {
  useEffect(() => { swap(`${API_URL}/api/domain-page?host=${encodeURIComponent(window.location.host)}`); }, []);
  return <div data-testid="domain-page-loading" />;
}
